import { useState, useEffect } from 'react';
import './forexbooking.css';

function ForexBooking() {
  const [tab, setTab] = useState(0);
  const [formData, setFormData] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [loading, setLoading] = useState(true);
  const [highestTab, setHighestTab] = useState(0);
  const [tabStatus, setTabStatus] = useState([false, false, false]);
  const [showTerms, setShowTerms] = useState(false);
  const [addressMode, setAddressMode] = useState('saved'); 
  const [savedAddresses, setSavedAddresses] = useState([
    {
      id: 1,
      name: 'Home',
      phone: '9864234562',
      address: '123 Main St',
      city: 'Mumbai',
      state: 'Maharashtra',
      pinCode: '400706',
      landmark: 'Near Park'
    }
  ]);

  const [deliveryMode, setDeliveryMode] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [processingTime, setProcessingTime] = useState('');
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const mockPrices = {
    totalamt: 40000,
    gst: 2000,
    grandtotal: 42000
  };

  const mockData = [
    {
      id: 1,
      orderType: "BUY",
      city: "Mumbai",
      currency: "USD",
      currencyWant: "USD",
      product: "Forex Card",
      inrAmount: "10000",
      editable: false
    },
    {
      id: 2,
      orderType: "SELL",
      city: "Goa",
      currency: "DINAR",
      currencyWant: "YEN",
      product: "Other",
      inrAmount: "20000",
      editable: false
    }
  ];

  useEffect(() => {
    fetch('https://your-backend-api.com/formdata')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Backend API error');
        }
        return response.json();
      })
      .then((data) => {
        setFormData(data);
        setLoading(false);
      })
      .catch(() => {
        console.warn('Backend fetch failed, using mock data');
        setFormData(mockData);
        setLoading(false);
      });
  }, []);

  const nextTab = () => {
    setTab((prevTab) => {
      const newTab = prevTab + 1;
      setHighestTab((prevHighest) => Math.max(prevHighest, newTab));
      return newTab;
    });
  };

  const handleInputChange = (e, formId, field) => {
    const updatedFormData = formData.map((form) => {
      if (form.id === formId) {
        return { ...form, [field]: e.target.value };
      }
      return form;
    });
    setFormData(updatedFormData);
  };

  const addProduct = () => {
    const newForm = {
      id: formData.length + 1,
      orderType: "BUY",
      city: "Mumbai",
      currency: "USD",
      currencyWant: "USD",
      product: "Forex Card",
      inrAmount: "",
      editable: true
    };
    setFormData([...formData, newForm]);
  };

  const saveToBackend = (formId) => {
    const formToSave = formData.find((form) => form.id === formId);
    if (!formToSave) return;

    fetch('https://your-backend-api.com/save', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formToSave),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Form saved successfully:', data);
        resetForm(formId);
      })
      .catch((error) => {
        console.error('Error saving form to backend:', error);
        saveToMockData(formToSave);
      });
  };

  const saveToMockData = (formData) => {
    const updatedMockData = [...mockData, formData];
    console.log('Form saved to mock data:', updatedMockData);
  };

  const resetForm = (formId) => {
    const updatedFormData = formData.map((form) => {
      if (form.id === formId) {
        return { ...form, inrAmount: "", editable: false };
      }
      return form;
    });
    setFormData(updatedFormData);
  };

 
  const markTabAsComplete = (tabIndex) => {
    const updatedTabStatus = [...tabStatus];
    updatedTabStatus[tabIndex] = true;
    setTabStatus(updatedTabStatus);
  };

  const [deliveryData, setDeliveryData] = useState({
    phone: '9864234562',
    address: '',
    city: 'Mumbai', 
    state: 'Maharashtra',
    pinCode: '400706',
    landmark: '',
    selfCollect: false
  });

  const handleDeliveryChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'selfCollect' && checked) {
      setShowTerms(true);
    }
    setDeliveryData(prev => ({
      ...prev,  
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const TermsModal = () => (
    <div className="terms-overlay">
      <div className="terms-content">
        <h3>Terms & Conditions</h3>
        <p>Please read and accept the following terms:</p>
        <ul>
          <li>Valid ID proof required at delivery</li>
          <li>Original documents must be presented</li>
          <li>No third party collection allowed</li>
        </ul>
        <button onClick={() => setShowTerms(false)}>I Accept</button>
      </div>
    </div>
  );

  return (
    <div className='pagecontent'>
      <>
        {tab === 0 ? (
          <div style={{display:'flex',flexDirection:'row',width:'100%'}}>
            <div className={`concentric-cir-1${tabStatus[0] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[0] ? '-completed' : ''}`}>
                1
              </div>
            </div>
            <div className="tabtitleopen" style={{paddingTop:'none !important',marginTop:'none !important'}}>
              <div>Order Details</div>

              {formData.map((form) => (
                <form key={form.id} className="formofforex">
                  {form.editable ? (
                    <div className='concentric'>
                      <div style={{ borderColor: '#777777' }} className='circleout'>
                        <div style={{ backgroundColor: '#777777' }} className='circlein'></div>
                      </div>
                    </div>
                  ) : (
                    <div className='concentric'>
                      <div className='circleout'>
                        <div className='circlein'></div>
                      </div>
                    </div>
                  )}
                  <div className="formrow1">
                    <div className="forminput1">
                      <div>Order Type</div>
                      <div>{form.orderType}</div>
                    </div>
                    <div className="forminput1">
                      <label>City</label>
                      <select
                        value={form.city}
                        onChange={(e) => handleInputChange(e, form.id, 'city')}
                        disabled={!form.editable}
                      >
                        <option value="Mumbai">Mumbai</option>
                        <option value="Goa">Goa</option>
                        <option value="Kolkata">Kolkata</option>
                      </select>
                    </div>
                    <div className="forminput1">
                      <label>Your Currency</label>
                      <select
                        value={form.currency}
                        onChange={(e) => handleInputChange(e, form.id, 'currency')}
                        disabled={!form.editable}
                      >
                        <option value="USD">USD</option>
                        <option value="DINAR">DINAR</option>
                        <option value="YEN">YEN</option>
                      </select>
                    </div>
                    <div className="forminput1">
                      <label>Currency You Want</label>
                      <select
                        value={form.currencyWant}
                        onChange={(e) => handleInputChange(e, form.id, 'currencyWant')}
                        disabled={!form.editable}
                      >
                        <option value="USD">USD</option>
                        <option value="DINAR">DINAR</option>
                        <option value="YEN">YEN</option>
                      </select>
                    </div>
                  </div>

                  <div className="formrow2">
                    <div className="forminput1">
                      <label>Product</label>
                      <select
                        value={form.product}
                        onChange={(e) => handleInputChange(e, form.id, 'product')}
                        disabled={!form.editable}
                      >
                        <option value="Forex Card">Forex Card</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="forminput1">
                      <label>INR Amount</label>
                      <input
                        type="text"
                        value={form.inrAmount}
                        onChange={(e) => handleInputChange(e, form.id, 'inrAmount')}
                        disabled={!form.editable}
                      />
                    </div>
                  </div>

                  <div>
                    {form.editable ? (
                      <button type="button" onClick={() => { saveToBackend(form.id); markTabAsComplete(0); }}>
                        Add
                      </button>
                    ) : (
                      <button type="button" onClick={() => resetForm(form.id)}>
                        Reset
                      </button>
                    )}
                  </div>
                </form>
              ))}
              <div>
                <button type="button" onClick={addProduct}>
                  Add Product
                </button>
              </div>

              <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',marginTop:'50px',borderTop:'1px solid #777777',paddingTop:'20px'}}>
                <div style={{width:'70%'}}>
                  <div className='billdetails'>
                    <div>Currency</div>
                    <div>Product</div>
                    <div>Forex Amount</div>
                    <div>INR Amount</div>
                    <div></div>
                  </div>
                  <div>
                    {formData.map((form) => (
                      <div className='billamt' key={form.id}>
                        <div>{form.currency}</div>
                        <div>{form.product}</div>
                        <div>{form.currencyWant}</div>
                        <div>{form.inrAmount}</div>
                        <div>
                          <button>
                            <img src='/src/assets/mingcute_delete-2-fill.png' alt="delete" />
                          </button>
                        </div>
                      </div>
                    ))}

                </div>
                </div>
                <div className='deliverybill'>
                      <div className='billrow'>
                        <div>Total</div>
                        <div>₹ {mockPrices.totalamt.toLocaleString('en-IN')}</div>
                      </div>
                      <div className='billrow'>
                        <div>GST</div>
                        <div>₹ {mockPrices.gst.toLocaleString('en-IN')}</div>
                      </div>
                      <div className='billrow'>
                        <div>Grand Total</div>
                        <div>₹ {mockPrices.grandtotal.toLocaleString('en-IN')}</div>
                      </div>
                  </div>
                
                
              
              
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', bottom: '-50px' }}>
              <button onClick={nextTab}>Continue</button>
            </div>
          </div>
            </div>
            
        ) : (
          <div style={{display:'flex',flexDirection:'row'}}>
            <div className={`concentric-cir-1${tabStatus[0] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[0] ? '-completed' : ''}`}>
                1
              </div>
            </div>
            <div className="tabtitleclose">
              <div>Order Details</div>
              {highestTab > 0 && (
                <div onClick={() => setTab(0)} style={{ cursor: 'pointer' }}>
                  <img src='/src/assets/tdesign_edit-filled.png' alt="edit" />
                </div>
              )}
            </div>
          </div>
        )}

        {/* Tab 1 */}
        {tab === 1 ? (
          <div style={{display:'flex',flexDirection:'row'}}>
            <div className={`concentric-cir-1${tabStatus[1] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[1] ? '-completed' : ''}`}>
                2
              </div>
            </div>
            <div className='tabtitleopen'>
              <form className="formofcustomer">
                <div className="formrow1">
                  <div className="forminput1">
                    <label>First Name</label>
                    <input type="text" />
                  </div>
                  <div className="forminput1">
                    <label>Last Name</label>
                    <input type="text" />
                  </div>
                  <div className="forminput1">
                    <label>Email</label>
                    <input type="email" />
                  </div>
                  <div className="forminput1">
                    <label>Phone Number</label>
                    <input type="tel" />
                  </div>
                </div>

                <div className="formrow2">
                  <div className="forminput1">
                    <label>Address</label>
                    <input type="text" />
                  </div>
                  <div className="forminput1">
                    <label>Country</label>
                    <select>
                      <option value="India">India</option>
                      <option value="USA">USA</option>
                      <option value="UK">UK</option>
                    </select>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', bottom: '-10px' }}>
                </div>
              </form>
              <button style={{display:'flex',justifyContent:'center',alignItems:'center'}} onClick={() => { markTabAsComplete(1); nextTab(); }}>Continue</button>
            </div>
          </div>
        ) : (
          <div style={{display:'flex',flexDirection:'row'}}>
            <div className={`concentric-cir-1${tabStatus[1] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[1] ? '-completed' : ''}`}>
                2
              </div>
            </div>
            <div className="tabtitleclose">
              <div>Customer Details</div>
              {highestTab > 1 && (
                <div onClick={() => setTab(1)} style={{ cursor: 'pointer' }}>
                  <img src='/src/assets/tdesign_edit-filled.png' alt="edit" />
                </div>
              )}
            </div>
          </div>
        )}

        {/* Tab 2 */}
        {tab === 2 ? (
          <div style={{ display: 'flex', flexDirection: 'row',width:'100%' }}>
            <div className={`concentric-cir-1${tabStatus[2] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[2] ? '-completed' : ''}`}>
                3
              </div>
            </div>
            <div className='tabtitleopen'>
              <form className="Eligibility">
                <div className='forminput1'>
                  <label>Select Purpose</label>
                  <select>
                    <option value="Personal">Personal</option>
                    <option value="Business">Business</option>
                  </select>
                </div>

                <div>
                  <div className='fileuploadhead'>Upload Documents</div>
                  <div className='uploadfiles'>
                    <div className="upload-item">
                      <label htmlFor="aadhar">Aadhar</label>
                      <input type="file" id="aadhar" name="aadhar" />
                      <img alt="uploaded" />
                    </div>
                    <div className="upload-item">
                      <label htmlFor="passport">Passport</label>
                      <input type="file" id="passport" name="passport" />
                      <img alt="uploaded" />
                    </div>
                    <div className="upload-item">
                      <label htmlFor="bankStatement">Bank Statement</label>
                      <input type="file" id="bankStatement" name="bankStatement" />
                      <img alt="uploaded" />
                    </div>
                    <div className="upload-item">
                      <label htmlFor="addressProof">Address Proof</label>
                      <input type="file" id="addressProof" name="addressProof" />
                      <img alt="uploaded" />
                    </div>
                  </div>
                </div>
              </form>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px',width:'100%' }}>
                <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px',width:'100%' }} onClick={() => { markTabAsComplete(2); nextTab(); }}>Continue</button>
              </div>
              
            </div>
          </div>
        ) : (
          <div style={{display:'flex',flexDirection:'row'}}>

            <div className={`concentric-cir-1${tabStatus[2] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[2] ? '-completed' : ''}`}>
                3
              </div>
            </div>  
          
            <div className="tabtitleclose">
              <div>Eligibility</div>
              {highestTab > 2 && (
                <div onClick={() => setTab(2)} style={{ cursor: 'pointer' }}>
                  <img src='/src/assets/tdesign_edit-filled.png' alt="edit" />
                </div>
              )}
            </div>
          </div>
        )}

        {tab === 3 ? (
          <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <div className={`concentric-cir-1${tabStatus[3] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[3] ? '-completed' : ''}`}>
                4
              </div>
            </div>
            <div className='tabtitleopen'>
              <div>Delivery</div>
              
              <div className="address-selection">
                <button 
                  className={addressMode === 'saved' ? 'active' : ''}
                  onClick={() => setAddressMode('saved')}
                >
                  Saved Addresses
                </button>
                <button
                  className={addressMode === 'new' ? 'active' : ''}
                  onClick={() => setAddressMode('new')}
                >
                  New Address
                </button>
              </div>

              {addressMode === 'saved' ? (
                <div className="saved-addresses">
                  <div className='address-list'>
                      {savedAddresses.map(address => (
                        <div key={address.id}  style={{width:'45%'}}>
                            
                            <div className="address-details">
                              <div>{address.address}</div>
                              <div>{address.city}, {address.state} - {address.pinCode}</div>
                              <div>Phone: {address.phone}</div>
                            </div>
                        </div>
                      ))}
                    <div className='add-address' onClick={() => setAddressMode('new')}>
                      Add New Address
                    </div>
                  </div>
                  
                  <div className="delivery-options">
                    <div className="option-group">
                      <div className="option-title">Select Delivery Mode</div>
                      <div className="radio-group">
                        <label>
                          <input 
                            type="radio" 
                            name="deliveryMode"
                            value="home"
                            checked={deliveryMode === 'home'}
                            onChange={(e) => setDeliveryMode(e.target.value)}
                          />
                          Home Delivery
                        </label>
                        <label>
                          <input 
                            type="radio" 
                            name="deliveryMode"
                            value="pickup"
                            checked={deliveryMode === 'pickup'}
                            onChange={(e) => setDeliveryMode(e.target.value)}
                          />
                          Store Pickup
                        </label>
                      </div>
                    </div>

                    <div className="option-group">
                      <div className="option-title">Select Processing Time</div>
                      <div className="radio-group">
                        <label>
                          <input 
                            type="radio" 
                            name="processingTime"
                            value="express"
                            checked={processingTime === 'express'}
                            onChange={(e) => setProcessingTime(e.target.value)}
                          />
                          Express Delivery (2-3 days)
                        </label>
                        <label>
                          <input 
                            type="radio" 
                            name="processingTime"
                            value="standard"
                            checked={processingTime === 'standard'}
                            onChange={(e) => setProcessingTime(e.target.value)}
                          />
                          Standard Delivery (4-5 days)
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <form className="formofdelivery">
                  <div className="formrow1">
                    <div className="forminput1">
                      <label>Delivery Contact</label>
                      <div className="phone-input">
                        <span className="country-code">+91</span>
                        <input
                          type="tel"
                          name="phone"
                          value={deliveryData.phone}
                          onChange={handleDeliveryChange}
                          className="input-field"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="formrow1">
                    <div className="forminput1">
                      <label>Street Address</label>
                      <input
                        type="text"
                        name="address"
                        value={deliveryData.address}
                        onChange={handleDeliveryChange}
                        placeholder="Enter Address"
                        className="input-field"
                      />
                    </div>
                  </div>

                  <div className="formrow2">
                    <div className="forminput1">
                      <label>City</label>
                      <select
                        name="city"
                        value={deliveryData.city}
                        onChange={handleDeliveryChange}
                        className="input-field"
                      >
                        <option value="Mumbai">Mumbai</option>
                        <option value="Goa">Goa</option>
                        <option value="Kolkata">Kolkata</option>
                      </select>
                    </div>

                    <div className="forminput1">
                      <label>State</label>
                      <select
                        name="state"
                        value={deliveryData.state}
                        onChange={handleDeliveryChange}
                        className="input-field"
                      >
                        <option value="Maharashtra">Maharashtra</option>
                        <option value="Goa">Goa</option>
                        <option value="West Bengal">West Bengal</option>
                      </select>
                    </div>
                  </div>

                  <div className="formrow2">
                    <div className="forminput1">
                      <label>Pin Code</label>
                      <input
                        type="text"
                        name="pinCode"
                        value={deliveryData.pinCode}
                        onChange={handleDeliveryChange}
                        className="input-field"
                      />
                    </div>

                    <div className="forminput1">
                      <label>Landmark</label>
                      <input
                        type="text"
                        name="landmark"
                        value={deliveryData.landmark}
                        onChange={handleDeliveryChange}
                        placeholder="Enter Landmark"
                        className="input-field"
                      />
                    </div>
                  </div>

                  <div className="checkbox-container">
                    <input
                      type="checkbox"
                      id="selfCollect"
                      name="selfCollect"
                      checked={deliveryData.selfCollect}
                      onChange={handleDeliveryChange}
                    />
                    <label htmlFor="selfCollect">
                      I confirm that I will be present myself to collect the order at the time delivery
                    </label>
                  </div>
                </form>
              )}

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
                <button
                  type="button"
                  onClick={() => {
                    markTabAsComplete(3);
                    nextTab();
                  }}
                >
                  Continue
                </button>
              </div>
              
              {showTerms && <TermsModal />}
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <div className={`concentric-cir-1${tabStatus[3] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[3] ? '-completed' : ''}`}>
                4
              </div>
            </div>
            <div className='tabtitleclose'>
              <div>Delivery</div>
              {highestTab > 3 && (
                <div onClick={() => setTab(3)} style={{ cursor: 'pointer' }}>
                  <img src='/src/assets/tdesign_edit-filled.png' alt="edit" />
                </div>
              )}
            </div>
          </div>
        )}

        {tab === 4? (
          <div style={{ display: 'flex', flexDirection: 'row',width:'100%' }}>

            <div className={`concentric-cir-1${tabStatus[5] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[5] ? '-completed' : ''}`}>
                5
              </div>
            </div>

            <div className='tabtitleopen'>
              <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',paddingTop:'20px'}}>
                  <div style={{width:'70%'}}>
                    <div className='billdetails'>
                      <div>Currency</div>
                      <div>Product</div>
                      <div>Forex Amount</div>
                      <div>INR Amount</div>
                      <div></div>
                    </div>
                    <div>
                      {formData.map((form) => (
                        <div className='billamt' key={form.id}>
                          <div>{form.currency}</div>
                          <div>{form.product}</div>
                          <div>{form.currencyWant}</div>
                          <div>{form.inrAmount}</div>
                          <div>
                            <button>
                              <img src='/src/assets/mingcute_delete-2-fill.png' alt="delete" />
                            </button>
                          </div>
                        </div>
                      ))}

                  </div>
                  </div>
                  <div className='deliverybill'>
                        <div className='billrow'>
                          <div>Total</div>
                          <div>₹ {mockPrices.totalamt.toLocaleString('en-IN')}</div>
                        </div>
                        <div className='billrow'>
                          <div>GST</div>
                          <div>₹ {mockPrices.gst.toLocaleString('en-IN')}</div>
                        </div>
                        <div className='billrow'>
                          <div>Grand Total</div>
                          <div>₹ {mockPrices.grandtotal.toLocaleString('en-IN')}</div>
                        </div>
                    </div>
                  
                  
                
                
              </div>
              <div className='paymentsection'>
                <div className='payment-options'>
                  <label className='payment-option'>
                    <input 
                      type="radio" 
                      name="paymentMode"
                      value="upi"
                      checked={paymentMode === 'upi'}
                      onChange={(e) => setPaymentMode(e.target.value)}
                    />
                    <span>UPI</span>
                  </label>

                  <label className='payment-option'>
                    <input 
                      type="radio" 
                      name="paymentMode"
                      value="netbanking"
                      checked={paymentMode === 'netbanking'}
                      onChange={(e) => setPaymentMode(e.target.value)}
                    />
                    <span>Net Banking</span>
                  </label>

                  <label className='payment-option'>
                    <input 
                      type="radio" 
                      name="paymentMode"
                      value="debitcard"
                      checked={paymentMode === 'debitcard'}
                      onChange={(e) => setPaymentMode(e.target.value)}
                    />
                    <span>Debit Card</span>
                  </label>

                  <label className='payment-option'>
                    <input 
                      type="radio" 
                      name="paymentMode"
                      value="creditcard"
                      checked={paymentMode === 'creditcard'}
                      onChange={(e) => setPaymentMode(e.target.value)}
                    />
                    <span>Credit Card</span>
                  </label>
                </div>
                
                
                
                
                
                
                
                
              
              </div>

              <div>
                  {
                    paymentMode=='upi'&& (
                      <div>
                        <form>
                          <div className='paymentformrow1'>
                            <div>
                              <label>ENTER VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label>Bank Account linked to VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label> BANK IFSC CODE</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div className='paymentformrow2'>
                            <div>
                              <label> Special Instruction</label>
                              <input type="text" />
                            </div>
                          </div>
                        </form>
                      </div>
                  )}
                  {
                    paymentMode=='netbanking'&& (
                      <div className='paymentform'>
                        <form>
                          <div>
                            <div>
                              <label>ENTER VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label>Bank Account linked to VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label> BANK IFSC CODE</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div>
                            <div>
                              <label> Special Instruction</label>
                              <input type="text" />
                            </div>
                          </div>
                        </form>
                      </div>
                    )
                  }
                  {
                    paymentMode=='debitcard'&& (
                      <div className='paymentform'>
                        <form>
                          <div>
                            <div>
                              <label>ENTER VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label>Bank Account linked to VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label> BANK IFSC CODE</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div>
                            <div>
                              <label> Special Instruction</label>
                              <input type="text" />
                            </div>
                          </div>
                        </form>
                      </div>
                    )
                  }
                  {
                    paymentMode=='creditcard'&& (
                      <div>
                        <form className='paymentform'>
                          <div>
                            <div>
                              <label>ENTER VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label>Bank Account linked to VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label> BANK IFSC CODE</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div>
                            <div>
                              <label> Special Instruction</label>
                              <input type="text" />
                            </div>
                          </div>
                        </form>
                      </div>
                    )
                  }
                  {
                    paymentMode=='netbanking'&& (
                      <div className='paymentform'>
                        <form>
                          <div className='paymentformrow1'>
                            <div>
                              <label>ENTER VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label>Bank Account linked to VPA</label>
                              <input type="text" />
                            </div>

                            <div>
                              <label> BANK IFSC CODE</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div>
                            <div>
                              <label> Special Instruction</label>
                              <input type="text" />
                            </div>
                          </div>
                        </form>
                      </div>
                    )
                  }
                  <div>
                    <div className='tncrow1'>
                      <div>
                        <span style={{backgroundColor:'white',color:'black',borderRadius:'50%',height:'50px',width:'50px',justifyContent:'center',alignItems:'center'}}>i</span>Have you purchased or transferred foreign currency worth more than INR 700,000 in the present financial year including the current order? 
                      </div>
                      
                      <label className='payment-option'>
                            <input 
                              type="radio" 
                            />
                            <span>Yes</span>
                          </label>

                          <label className='payment-option'>
                            <input 
                              type="radio" 
                            />
                            <span>No</span>
                          </label>
                    </div>
                    <div className='tncrow2'>
                      *Have you purchased or transferred foreign currency worth more than INR 700,000 in the present financial year including the current order? 
                            
                    </div>
                    <div className="checkbox-container">
                    <input
                      type="checkbox"
                      id="selfCollect"
                      name="selfCollect"
                      checked={deliveryData.selfCollect}
                      onChange={handleDeliveryChange}
                    />
                    <label htmlFor="selfCollect">
                    <div className="checkbox-container">
                    
                  </div>
                    </label>
                  </div>

                  </div>
                  
                </div>
            </div>
            
          </div>
        ) : (
          <div style={{display:'flex',flexDirection:'row'}}>

            <div className={`concentric-cir-1${tabStatus[5] ? '-completed' : ''}`}>
              <div className={`concentric-cir-2${tabStatus[5] ? '-completed' : ''}`}>
                5
              </div>
            <div>
             
              <div>

                
                
                
              </div>
              
            </div>
            </div>  
          
            <div className="tabtitleclose">
              <div>Eligibility</div>
              {highestTab > 2 && (
                <div onClick={() => setTab(2)} style={{ cursor: 'pointer' }}>
                  <img src='/src/assets/tdesign_edit-filled.png' alt="edit" />
                </div>
              )}
            </div>
          </div>
        )}
      </>
    </div>
  );
}

export default ForexBooking;
